import styled from 'styled-components';

import { BaseStyle, Button } from '@nhl/nhl-breakaway-ui';

import { WithIsHome, WithTeam } from '~/core/styleTypes';

import { getEntityBackgroundColor, getEntityMarkerBorder, getEntityTextAndBorderColor } from '../../utils';

export const PPTReplayContainer = styled.div<{ $isEmbed: boolean }>`
    display: flex;
    position: relative;
    width: 100%;
    aspect-ratio: ${({ $isEmbed }) => ($isEmbed ? '1.785 / 1' : '1.86 / 1')};
`;

export const LoadingDisplayContainer = styled.div`
    position: absolute;
    display: flex;
    top: 0;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.75);
`;

export const EntityMarker = styled.circle<WithTeam & WithIsHome & { $isGoalScorer?: boolean }>`
    fill: ${({ theme, $teamAbbrev, $isHome }) =>
        $teamAbbrev ? getEntityBackgroundColor(theme, $isHome, $teamAbbrev) : theme.Text.primary};
    stroke: ${({ theme, $teamAbbrev, $isHome }) => getEntityMarkerBorder(theme, $teamAbbrev, $isHome)};
    stroke-width: ${({ $isGoalScorer }) => ($isGoalScorer ? 6 : 3)};
`;

export const EntityHalo = styled.circle<WithTeam & WithIsHome>`
    fill: none;
    stroke: ${({ theme, $teamAbbrev, $isHome }) => getEntityMarkerBorder(theme, $teamAbbrev, $isHome)};
    stroke-width: 6;
`;

export const SweaterNumber = styled.text<WithTeam & WithIsHome>`
    ${BaseStyle.Mixins.fontStyles.ui['48b']};
    text-anchor: middle;
    dominant-baseline: central;
    stroke-width: 3px;
    fill: ${({ theme, $teamAbbrev, $isHome }) => getEntityTextAndBorderColor(theme, $isHome, $teamAbbrev)};

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['40b']};
    }

    ${BaseStyle.Mixins.screenSizes.small} {
        ${BaseStyle.Mixins.fontStyles.ui['64b']};
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    padding: 8px;
    width: 100%;
    gap: 8px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        padding: 8px 16px;
    }

    ${BaseStyle.Mixins.screenSizes.small} {
        padding: 4px;
    }
`;

export const PptButton = styled(Button)`
    height: 32px;
    width: 32px;
    opacity: 0.25;
    padding: 12px;
    border: none;

    svg {
        ${BaseStyle.Mixins.fontStyles.ui['16b']}
        fill: ${({ theme }) => theme.Text.OppositeSurface.primary};
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        height: 40px;
        width: 40px;

        svg {
            ${BaseStyle.Mixins.fontStyles.ui['22b']}
        }
    }
`;

export const RestartContainer = styled.div`
    display: grid;
    place-items: center;
    position: absolute;
    height: 100%;
    top: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.75);
    text-align: center;
    color: ${({ theme }) => theme.Text.primary};
`;

export const RestartButton = styled(Button)`
    height: 60px;
    width: 60px;
    background: rgba(0, 0, 0, 0.5);
    padding: 0;

    svg {
        ${BaseStyle.Mixins.fontStyles.ui['36b']}
        fill: ${({ theme }) => theme.Text.OppositeSurface.primary};
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        height: 80px;
        width: 80px;

        svg {
            ${BaseStyle.Mixins.fontStyles.ui['48b']}
        }
    }

    ${BaseStyle.Mixins.screenSizes.small} {
        height: 40px;
        width: 40px;

        svg {
            ${BaseStyle.Mixins.fontStyles.ui['24b']}
        }
    }
`;

export const GameCenterLink = styled.a`
    margin-left: auto;
`;

export const GameCenterButton = styled(PptButton)`
    width: auto;
`;
